// Copyright (c) 2016 Deere & Company

import GeneralCsvSeparator, {getDefaultState as getCsvSeparatorDefaultState} from './general-csv-separator';
import GeneralDateFormat, {getDefaultState as getGeneralDateFormatDefaultState} from './general-date-format';
import GeneralDecimalFormat, {getDefaultState as getGeneralDecimalFormatDefaultState} from './general-decimal-format';
import GeneralTimeZone, {getDefaultState as getGeneralTimeZoneDefaultState} from './general-time-zone';
import t from 'tcomb';

const GeneralSettings = t.struct({
    csvSeparator: GeneralCsvSeparator,
    dateFormat: GeneralDateFormat,
    decimalFormat: GeneralDecimalFormat,
    timeZone: GeneralTimeZone
}, {
    name: 'GeneralSettings',
    strict: true
});

export const getDefaultState = () => new GeneralSettings({
    csvSeparator: getCsvSeparatorDefaultState(),
    dateFormat: getGeneralDateFormatDefaultState(),
    decimalFormat: getGeneralDecimalFormatDefaultState(),
    timeZone: getGeneralTimeZoneDefaultState()
});

export default GeneralSettings;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/general-settings.js